import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { deleteSimulationTemplate, deleteGroup, deleteSMTPConfig } from '../../../API/PhishingAPI';
import { templateOrganization } from '../TemplateGallery/templateOrganization';

const actions = { templates: deleteSimulationTemplate, groups: deleteGroup, smtp: deleteSMTPConfig };
export default function ChoiceDeleteModal({ target, onClose, onDeleted, t }) {
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const pending = useRef(false), mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);
  const { kind, item } = target;
  const name = kind === 'templates' ? templateOrganization(item, t).title : item.name;
  async function remove() {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError('');
    try {
      const result = await actions[kind](item.id);
      if (mounted.current) onDeleted(kind, item, result);
    } catch (error) {
      if (mounted.current) setError(Number(error.code) === 409 ? t(`simulation_wizard.delete_in_use_${kind}`)
        : t('simulation_wizard.delete_error', { message: error.message || '' }));
    } finally { pending.current = false; if (mounted.current) setBusy(false); }
  }
  function close() { if (!pending.current) onClose(); }
  return <Modal isOpen toggle={close} backdrop={busy ? 'static' : true}>
    <ModalHeader toggle={busy ? undefined : close}>{t(`simulation_wizard.delete_title_${kind}`)}</ModalHeader>
    <ModalBody><p>{t('simulation_wizard.delete_confirm', { name })}</p>
      <p className="text-muted">{t(`simulation_wizard.delete_details_${kind}`)}</p>
      {error && <Alert color="danger" role="alert">{error}</Alert>}
    </ModalBody>
    <ModalFooter><Button color="link" disabled={busy} onClick={close}>{t('actions.cancel')}</Button>
      <Button color="danger" disabled={busy} onClick={remove}>{busy && <Spinner size="sm" className="mr-2" />}{t('simulation_wizard.delete_action')}</Button>
    </ModalFooter>
  </Modal>;
}
